// import {
//   HttpInterceptor,
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpErrorResponse,
// } from '@angular/common/http';

// import { Observable } from 'rxjs';
// import { tap } from 'rxjs/operators';
// import { StorageService } from './storage.service';
// import { NavigatorService } from './navigator.service';
// import notify from 'devextreme/ui/notify';
// import { AuthService } from '.';

// export class SecurityHeaderInterceptorService {
//   constructor(
//     private ss: StorageService,
//     private as: AuthService,
//   ) {}

//   intercept(
//     req: HttpRequest<any>,
//     next: unknown,
//     next: HttpHandler,
//   ): Observable<HttpEvent<any>> {
//     // Clone the request to add the new header
//     if (this.ss.currentToken) {
//       const clonedRequest = req.clone({
//         setHeaders: { Authorization: `Bearer ${this.ss.currentToken}` },
//       });
//       return next.handle(clonedRequest).pipe(
//         tap(
//           () => {},
//           (err: any) => {
//             if (err instanceof HttpErrorResponse) {
//               if (err.status !== 401) {
//                 return;
//               }
//               this.as.logOut();
//               notify(
//                 `Accesso scaduto: è necessario fare login`,
//                 'warning',
//                 1000,
//               );
//             }
//           },
//         ),
//       );
//     } else {
//       return next.handle(req).pipe(
//         tap(
//           () => {},
//           (err: any) => {
//             if (err instanceof HttpErrorResponse) {
//               if (err.status !== 401) {
//                 return;
//               }
//               notify(`È necessario fare login`, 'warning', 1000);
//               this.as.logOut();
//             }
//           },
//         ),
//       );
//     }
//   }
// }


import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import notify from 'devextreme/ui/notify';

import { StorageService } from './storage.service';
import { AuthService } from './auth.service';

export const SecurityHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const ss = inject(StorageService);
  const auth = inject(AuthService);

  let requestToSend = req;

  if (ss.currentToken) {
    requestToSend = req.clone({
      setHeaders: {
        Authorization: `Bearer ${ss.currentToken}`
      }
    });
  }

  return next(requestToSend).pipe(
    tap({
      error: (err: any) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {

          // Messaggio differenziato
          if (ss.currentToken) {
            notify('Accesso scaduto: è necessario fare login', 'warning', 1000);
          } else {
            notify('È necessario fare login', 'warning', 1000);
          }

          auth.logOut();
        }
      }
    })
  );
};